import React from 'react';
import { useIntl } from 'react-intl';
import ReactGA from 'react-ga';

import Footer from '../../Footer';

import RequestModal from '../../RequestModal';
import styles from './FooterScreen.module.css';
import {ASK_AN_EXPERT_LANGING_BOTTOM} from '../../../utils/constants';

const FooterScreen = (props) => {
  const { showModal } = props;

  const { formatMessage } = useIntl();

  return (
    <>
      <div className={styles['body-container']}>
        <div className={`${styles['title']} Rubik-60pt`}>
          {formatMessage({id: 'FooterScreen.title'})}
        </div>
        <div className={`${styles['subtitle']} Rubik-26pt`}>
          {formatMessage({id: 'FooterScreen.text'})}
        </div>
        <div className={styles['button-container']}>
          <button className={`${styles['ask-button']} Rubik-20pt`} onClick={() => {
            ReactGA.set({ dimension9: ASK_AN_EXPERT_LANGING_BOTTOM });
            showModal(RequestModal)
          }}>
            { formatMessage({id: 'Header.askAnExpert'}) }
          </button>
        </div>
        <div className={styles['footer-container']}>
          <Footer></Footer>
        </div>
      </div>
    </>
  );
};

export default FooterScreen;
